export const ERROR_MESSAGES = {
    required: 'system.messages.errors.required-field'
}